import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { ReportService } from '../../reportService';

@Component({
  selector: 'app-saved-search-report',
  templateUrl: './saved-search-report.component.html',
  styleUrls: ['./saved-search-report.component.scss']
})
export class SavedSearchReportComponent implements OnInit, OnDestroy {

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  savedSearchId: any = 0;
  reportName: string = '';

  constructor(
    private route: ActivatedRoute,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
      const reportId = param.params.id;
      this.savedSearchId = 0;
      this.getReportData(reportId);
    });
  }

  getReportData(reportId) {
    this.reportService.getReportDataById(reportId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp) => {
      this.reportName = resp.reportName;
      this.savedSearchId = resp.savedSearchId;
    })
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
